import playbackRequest from './playback.request';
import createService from '../Utils/createService';
import handlePlaybackServiceError from './Utils/handlePlaybackServiceError';
import { ServiceTypes } from '../Constants/api.constants';
import {
    RETRY_COUNT_API_SERVICE_PLAYBACK,
} from '../../Errors/Constants/Error.retries';
import interceptPlaybackServiceResponse from './Utils/interceptPlaybackServiceResponse';

const createPlaybackService = (configStoreUpdate$, handleError) =>
    createService(
        ServiceTypes.PLAYBACK,
        configStoreUpdate$,
        playbackRequest,
        handlePlaybackServiceError(handleError),
        RETRY_COUNT_API_SERVICE_PLAYBACK,
        interceptPlaybackServiceResponse(handleError)
    );

export default createPlaybackService;
